export const LEAD = process.env.REACT_APP_LEAD === 'true';
export const BETA = process.env.REACT_APP_NEXT === 'true';

export const STATE_BEWERTET = 'S_BEWERTET';
export const STATE_GEPLANT = 'S_GEPLANT';
export const STATE_VORLAUF = 'S_VORLAUF';
export const STATE_BESTAND = 'S_BESTAND';
export const STATE_BESTELLT = 'S_BESTELLT'; // Bestellung vorhanden (z.B. bei Fugel)
export const STATE_VERKAUFT = 'S_VERKAUFT'; // je nach Einstellung entweder durch Bestellung oder durch Zahlung

export const MAX_INTEGER_PRICE = 2147483600;

export const GOOGLE_MAPS_API_KEY = 'AIzaSyBC7hg9ya7HeQ4RdASbvaQCMmnv8q24w-w';

export const maskBIC = {
    definitions: { '#': /\d|\w/ },
    mask: '###########',
};

export const maskIBAN = {
    definitions: { '#': /\w/, '@': /\d/ },
    mask: '##@@ @@@@ @@@@ @@@@ @@@@ @@{@@ @@@@}',
};

export const maskVIN = {
    definitions: { '#': /[0-9a-hA-Hj-nJ-NpPr-zR-Z]/ },
    mask: '#################',
};
